var map = {
	"./assets/clickable/google.svg": "a660a97f853d78cb3283",
	"./assets/disabled/google.svg": "58e0966669127dcac7b3",
	"./assets/original/google.svg": "9728ed606707ff10c811"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f9401ad35f51b53771b";